import { writable } from 'svelte/store';

export const workspace = writable({});


export const userdata = writable({})